import React from 'react';
import { Box } from '../box';

export type BodyProps = {
  children?: React.ReactNode;
  className?: string;
  fixed?: boolean;
};

export const Body: React.FC<BodyProps> = ({ children, className, fixed }) => {
  return (
    <Box
      className={`
      ${fixed ? 'fixed' : 'relative'}
      z-0
      overflow-hidden
      flex
      flex-col
      min-h-svh
      w-svw
      ${className}
    `}
    >
      {children}
    </Box>
  );
};
